// extracted by mini-css-extract-plugin
module.exports = {"container":"EditAuthorModale_container__2Wjo9","card":"EditAuthorModale_card__10Rwq","info-row":"EditAuthorModale_info-row__1-9e3","info-col":"EditAuthorModale_info-col__2EUui"};